import React from "react";
const ErrorLabelComponent = (props) => {
    const {shouldView = true, text = ''} = props;
    return (<p className={shouldView ? 'text-red-500 text-xs italic' : 'hidden'}>{text}</p>);
};

export default ErrorLabelComponent;
